<template>
    <a-drawer
:maskClosable="false"
width="65%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
        :destroyOnClose="true">
        <a-divider orientation="left">
            <b>{{ formTitle }}</b>
        </a-divider>
        <userAgent v-if="type == 1 || type == 4" @changeAgent="changeAgent" :tenantId="id"></userAgent>
        <storagePackage v-if="type == 2" :isSingleSelect="true" @changeTao="changeTao" :packageId="id">
        </storagePackage>
        <storagePool ref="storagePool" v-if="type == 5" :isSingleSelect="true" @changeCun="changeCun"></storagePool>
        <controPage v-if="type == 3" ref="controPage" :couponId="id" @changeYou="changeYou"></controPage>
    </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import { getObj, addObj, putObj } from '@/api/VR/storagePackage'
import parameter from '@/mixins/parameter'
import userAgent from './userAgent.vue'
// import up from './userAgent.vue'
import storagePackage from '../../storagePackage/indexs.vue'
import controPage from '../../storagePackage/controPage.vue'
import storagePool from '../../storagePool/index.vue'
export default {
    name: 'CreateForm',
    components: { userAgent, storagePackage, controPage, storagePool },
    mixins: [parameter],
    data() {
        return {
            submitLoading: false,
            showLoading: false,
            id: '',
            data: [],
            type: '',
            formTitle: '',
            // 表单参数
            form: {
                id: undefined,
                allocateCapacity: 5,
                enterpriseOwnPoolId: undefined,
                agentTenantId: undefined,
                sort: 99,
            },
            open: false,
            hour: [],
            hours: [],
            minute: [],
            minutes: [],
            rules: {
                capacity: [{ required: true, message: '请输入套餐容量(MB)', trigger: 'blur' }],
                packageName: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
                sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
                packageType: [{ required: true, message: '请选择套餐类型', trigger: 'blur' }],
                unitPrice: [{ required: true, message: '请输入单价(元/GB)', trigger: 'blur' }],
                price: [{ required: true, message: '请输入套餐价格', trigger: 'blur' }],
                validDays: [{ required: true, message: '请输入有效期(天)', trigger: 'blur' }],
            },
        }
    },
    filters: {},
    created() {
        console.log('statusOptions 显示隐藏', this.infoUser)
    },
    computed: {
        ...mapGetters(['userTentant', 'infoUser']),
    },
    watch: {},
    methods: {
        onClose() {
            this.open = false
            //   this.$confirm({
            //     title: '是否确认关闭清空数据',
            //     onOk() {
            //       console.log(that.open, 'openopen')
            //       that.open = false
            //     },
            //     onCancel() {},
            //   })
        },

        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        // 点击存储池返回
        changeCun(e) {
            this.$emit('changeCun', e)
            this.open = false
        },
        // 代理返回
        changeAgent(e) {
            this.$emit('changeAgent', e)
            this.open = false
        },
        // 套餐返回
        changeTao(e) {
            this.$emit('changeTao', e)
            this.open = false
        },
        // 优化券返回返回
        changeYou(e) {
            this.$emit('changeYou', e)
            this.open = false
        },
        // 取消按钮
        cancel() {
            this.onClose()
            this.reset()
        },
        // 表单重置
        reset() {
            this.form = {
                id: undefined,
                allocateCapacity: 5,
                enterpriseOwnPoolId: undefined,
                agentTenantId: undefined,
                sort: 99,
            }
        },
        /** 新增按钮操作 */
        handleAdd(e, id) {
            console.log(e, id, '顶顶顶顶')
            this.type = e
            this.id = id
            this.reset()
            this.open = true
            if (e == 1) {
                this.formTitle = '分配代理'
            } else if (e == 2) {
                this.formTitle = '选择套餐'
                console.log(id, '的点点滴滴')
            } else if (e == 3) {
                this.formTitle = '选择优惠券'
            } else if (e == 4) {
                this.formTitle = '经销商'
            } else if (e == 5) {
                this.formTitle = '存储池'
            }
        },
        /** 修改按钮操作 */
        handleUpdate(row, ids) {
            this.reset()
            const postId = row ? row.id : ids
            getObj(postId).then((response) => {
                this.form = response.data
                this.open = true
                this.formTitle = '修改'
            })
        },
        /** 提交按钮 */
        submitForm: function () {
            console.log(this.form, '对对对对对对')

            this.$refs.form.validate((valid, object) => {
                if (valid) {
                    this.submitLoading = true
                    this.showLoading = true
                    this.$nextTick(() => {
                        this.$refs.LoadingPop.init(1)
                    })
                    if (this.form.id !== undefined) {
                        putObj(this.form)
                            .then((response) => {
                                this.$message.success('修改成功', 3)
                                this.open = false
                                this.$emit('ok')
                            })
                            .finally(() => {
                                this.submitLoading = false
                                this.showLoading = false
                            })
                    } else {
                        addObj(this.form)
                            .then((response) => {
                                this.$message.success('新增成功', 3)
                                this.open = false
                                this.$emit('ok')
                            })
                            .finally(() => {
                                this.submitLoading = false
                                this.showLoading = false
                            })
                    }
                } else {
                    const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
                    this.showLoading = true
                    this.$nextTick(() => {
                        this.$refs.LoadingPop.init(2, messages)
                    })
                    return false
                }
            })
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.ant-form-item {
    margin-bottom: 0 !important;
}

.input_d {
    display: flex;
    align-items: center;
}
</style>
